import { render, staticRenderFns } from "./ClientAutocomplete.vue?vue&type=template&id=a54cdf28&"
import script from "./ClientAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ClientAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports